import axios from 'axios'

export default {
  registerDemo(data) {
    return axios.post(`${process.env.VUE_APP_ROOT_API}/demo/register`, data)
  },
}
